import { Grid, Filter, Page, Sort, RecordClickEventArgs, Toolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { AddOrUpdateDocumentationTopicManager, AddOrUpdateSoftwareVersionManager } from '../../Exporters/ManagersExporter';

export class VersionHistoryManager {

    constructor(private containerElement: JQuery) { }
    
    private addOrUpdateVersionHistoryModalHelper : ModalHelper;
    private addOrUpdateVersionHistoryManager : AddOrUpdateSoftwareVersionManager;

    private versionHistoryGrid : Grid;


    public initialize() {
        var self = this;

        this.addOrUpdateVersionHistoryModalHelper = new ModalHelper();
        this.addOrUpdateVersionHistoryModalHelper.createModal("add-or-update-version-history-popup", true);

        Grid.Inject(Page, Sort, Toolbar);

        self.initializeVersionHistory();
    }

    private initializeVersionHistory() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var versionHistoryContainer = self.containerElement.find('#admin-version-history-items-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;


        let data: DataManager = new DataManager({
            url: '/api/information/versionhistory',
            adaptor: new WebApiAdaptor
        });

        self.versionHistoryGrid = new Grid(
            {
                height: '100%',
                toolbarTemplate: '#toolbar-template',
                dataSource: data,
                columns: [
                    { field: 'SoftwareVersion', headerText: 'Version', width: 150},
                    { field: 'SoftwareVersionDateString', headerText: 'Version date'},
                ],
                allowSorting: false,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                pageSettings: { pageSize: 2000 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                    loadingContainer.addClass('d-none');
                    versionHistoryContainer.removeClass('d-none');
                },
                recordDoubleClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var versionHistoryId = args.rowData["Id"];
                        if(versionHistoryId != undefined) {
                            self.addOrUpdateVersionHistoryModalHelper.load(`?id=${versionHistoryId}&handler=AddOrUpdateSoftwareVersion`, undefined, () => {
                                if(self.addOrUpdateVersionHistoryManager == undefined) {
                                    self.addOrUpdateVersionHistoryManager = new AddOrUpdateSoftwareVersionManager(self.addOrUpdateVersionHistoryModalHelper.getModalContainer());
                                }
                
                                self.addOrUpdateVersionHistoryManager.initialize();
                            }, 
                            () => {
                                self.versionHistoryGrid.refresh();
                            });
                        }
                    }
                }
            });

        self.versionHistoryGrid.appendTo('#Grid');

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var addButton = toolbar.find('#add-button');
            addButton.off('click').on('click', () => {
                self.addOrUpdateVersionHistoryModalHelper.load(`?handler=AddOrUpdateSoftwareVersion`, undefined, () => {
                    if(self.addOrUpdateVersionHistoryManager == undefined) {
                        self.addOrUpdateVersionHistoryManager = new AddOrUpdateSoftwareVersionManager(self.addOrUpdateVersionHistoryModalHelper.getModalContainer());
                    }
    
                    self.addOrUpdateVersionHistoryManager.initialize();
                }, 
                () => {
                    self.versionHistoryGrid.refresh();
                });
            })

        }

        (<any>window).initializeAddOrUpdateSoftwareVersion = () => {
            self.addOrUpdateVersionHistoryManager.initialize();
        }
    }

}